import {Header, Pagination, TableSkeleton} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import UserFilters from '@/screens/User/List/UserFilters';

import MerchantUserTable from './MerchantUserTable';
import useMerchantUserList from './useMerchantUserList';

const MerchantUserList = () => {
  const {
    isLoading,
    isSearch,
    isPageReset,
    fetchAllMerchants,
    pageInfo,
    filterCount,
    currentFilters,
    filtersToApply,
    handleApplyFilters,
    clearFilters,
    handleUserAutoComplete,
    selectAppliedFilters,
    selectCurrentFilters,
    merchantList,
  } = useMerchantUserList();

  const renderList = () => {
    if (isLoading) {
      return <TableSkeleton />;
    }

    if (!merchantList || !merchantList.length) {
      return (
        <div className="flex items-center gap-1 justify-center mt-5">
          <p
            className="text-gray-800 dark:text-white"
            data-cy="merchant-users-empty-state"
          >
            No Users found.
          </p>
        </div>
      );
    }

    return <MerchantUserTable merchants={merchantList} />;
  };

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={'Business Users'} dataCy="merchant-users-title" />

      <UserFilters
        filterCount={filterCount}
        currentFilters={currentFilters}
        filtersToApply={filtersToApply}
        clearFilters={clearFilters}
        selectCurrentFilters={selectCurrentFilters}
        selectAppliedFilters={selectAppliedFilters}
        handleApplyFilters={handleApplyFilters}
        handleAutoComplete={handleUserAutoComplete}
        isMerchant={true}
        dataCy="merchant-users"
      />

      <section className="pt-5 md:pt-5">{renderList()}</section>

      {merchantList && merchantList.length ? (
        <Pagination
          onPageChange={fetchAllMerchants as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </main>
  );
};

export default MerchantUserList;
